export default __webpack_public_path__ + "static/media/ic_kucoin.d4526877.svg";